// Strat de acces la date — SINGURUL loc din UI care „știe" de unde vin datele.
//
// SURSA e gestionată de `store.ts` și poate fi:
//   - "demo"     → JSON static generat din mock (fișierele din acest folder).
//   - "imported" → Excel/CSV încărcat de utilizator (exporturi WinMentor/Optima),
//                  parsate în browser și persistate în localStorage.
//
// CÂND VINE ACCESUL LIVE WINMENTOR/OPTIMA (faza 2): se adaugă un al treilea mod
// ("live") care face `fetch("/api/marts/...")` peste warehouse-ul real. Componentele
// din src/components/sections/* consumă exclusiv tipurile din src/types.ts și
// getterele de mai jos — NU trebuie modificate.

import type {
  ComandaRow,
  CostProductieRow,
  DataMeta,
  ExportSplitRow,
  ExportTrendRow,
  IncarcareMasinaRow,
  MediaMobilaRow,
  PierdereRow,
  ProductivitateOperatorRow,
  ProfitabilitateRow,
} from "@/types";

import { effective, getInfo, isImported } from "./store";

export function getCostProductie(): CostProductieRow[] {
  return effective().cost_productie;
}

export function getMediaMobila(): MediaMobilaRow[] {
  return effective().media_mobila;
}

export function getProfitabilitate(): ProfitabilitateRow[] {
  return effective().profitabilitate;
}

export function getIncarcareMasini(): IncarcareMasinaRow[] {
  return effective().incarcare_masini;
}

export function getProductivitateOperatori(): ProductivitateOperatorRow[] {
  return effective().productivitate_operatori;
}

export function getExportSplit(): ExportSplitRow[] {
  return effective().export_split;
}

export function getExportTrend(): ExportTrendRow[] {
  return effective().export_trend;
}

export function getComenzi(): ComandaRow[] {
  return effective().comenzi;
}

export function getPierderi(): PierdereRow[] {
  return effective().pierderi;
}

/** True dacă avem fact-ul granular „comenzi" disponibil pentru filtrare/drill-down.
 *  Demo îl are mereu; în modul importat doar dacă utilizatorul l-a încărcat. */
export function hasComenzi(): boolean {
  if (getInfo().mode !== "imported") return true; // demo
  return isImported("comenzi");
}

export function hasPierderi(): boolean {
  if (getInfo().mode !== "imported") return true;
  return isImported("pierderi");
}

export function getMeta(): DataMeta {
  const info = getInfo();
  if (info.mode === "imported") {
    return {
      sursa: "marts",
      generat_la: info.importedAt ?? new Date().toISOString(),
      nota: "Date importate de utilizator din exporturi Excel/CSV (WinMentor/Optima).",
    };
  }
  return {
    sursa: "mock",
    generat_la: "2026-07-13T18:20:34.997922Z",
    nota: "Date sintetice (mock). Importă exporturile tale din panoul de import sau așteaptă conectorul live WinMentor (faza 2).",
  };
}
